import Flickity from 'flickity';

/**
 * Value Props
 * @param {object} opts
 */
function valueProps(opts) {
  const config = {
    dom: {
      wrapper: 'js-value-props',
      carousel: 'js-value-props-carousel',
    },
  };
  const c = __.extend(config, opts);

  const flickityOpts = {
    contain: true,
    dragThreshold: 10,
    draggable: true,
    pageDots: false,
    prevNextButtons: false,
    wrapAround: true,
  };

  // global elements
  const $wrappers = document.body.querySelectorAll(`.${c.dom.wrapper}`);
  const flickityCarousels = [];
  let view;

  /**
   * Init
   */
  function init() {
    if (!$wrappers?.length) return;
    onWindowResize();
    __.windowResize(onWindowResize);
  }

  /**
   * On Window Resize
   */
  function onWindowResize() {
    // desktop
    __.mq({
      view: 'desktop',
      callback: () => {
        if (view !== 'desktop') {
          view = 'desktop';
          rebuildFlickity();
        }
      },
    });

    // mobile
    __.mq({
      view: 'mobile',
      callback: () => {
        if (view !== 'mobile') {
          view = 'mobile';
          rebuildFlickity();
        }
      },
    });
  }

  /**
   * rebuild flickity
   */
  function rebuildFlickity() {
    [...$wrappers].forEach(($wrapper, index) => {
      const activeCarousel = flickityCarousels[index];
      if (activeCarousel) activeCarousel.destroy();
      const $carousel = $wrapper.querySelector(`.${c.dom.carousel}`);
      if (!$carousel || view === 'desktop') return;

      setTimeout(() => {
        if (activeCarousel) {
          flickityCarousels[index] = new Flickity($carousel, flickityOpts);
        } else {
          flickityCarousels.push(new Flickity($carousel, flickityOpts));
        }
      }, 500); // short timeout for Flickity cell sizing
    });
  }

  return init();
}

export default valueProps;
